import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getLatestReceipt,
  getReceiptById,
  getUpdatedReceipt,
} from "../../../utils/APICalls/APICalls";

export const getLatestReceiptThunk = createAsyncThunk(
  "fetchReceipt",
  async (payload: { franchiseId: number }) => {
    return await getLatestReceipt(payload.franchiseId);
  }
);

export const getReceiptByIdThunk = createAsyncThunk(
  "fetchReceiptById",
  async (payload: { receiptId: number }) => {
    return await getReceiptById(payload.receiptId);
  }
);

export const fetchUpdatedReceipt = createAsyncThunk(
  "fetchUpdatedReceipt",
  async (payload: { receiptId: number; restaurantId: number }) => {
    return await getUpdatedReceipt(payload.receiptId, payload.restaurantId);
  }
);
